import Vue from "vue"
import Vuex from "vuex"
import VueResource from "vue-resource"
import VeeValidate from "vee-validate"
import VueI18n from "vue-i18n"
import VueTippy, { TippyComponent } from "vue-tippy";
import enValidationMessages from "vee-validate/dist/locale/en"
import messages from "./messages"

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(VueResource)

const languageMeta = document.querySelector("meta[name=language]")
const language = languageMeta ? languageMeta.getAttribute('content') : "en"
const i18n = new VueI18n({
  locale: language,
  fallbackLocale: "en",
  messages: messages
})

Vue.use(VeeValidate, {
  i18n,
  useConstraintAttrs: false,
  dictionary: {
    en: enValidationMessages
  }
})

Vue.http.headers.common["Content-Type"] = "application/json"

const setCSRFToken = () => {
  const token = document.querySelector("meta[name=csrf-token]").getAttribute("content")
  Vue.http.headers.common["X-CSRF-Token"] = token
}

setCSRFToken()
document.addEventListener("turbolinks:load", setCSRFToken)

// Global directives
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

export const buildAndMountApp = (host, app, store, props = {}) => {
  new Vue({
    store,
    i18n,
    render: h => h(app, {props})
  }).$mount(host)
}

export default Vue
